// Libellés français des sous-catégories du catalogue (codes renvoyés par le backend).
const SUB_CATEGORY_LABELS = {
    CEREAL: "céréales",
    LEGUME: "légumineuses",
    TUBER: "tubercules",
    VEGETABLE: "légumes",
    FRUIT: "fruits",
    SPICE: "épices",
    HERB: "herbes aromatiques",
    FLOWER: "fleurs",
    TREE: "arbres",
    CATTLE: "bovins",
    GOAT: "caprins",
    SHEEP: "ovins",
    POULTRY: "volailles",
    SEA_PRODUCT: "produits de la mer",
    METHANOL: "méthanol",
    PROPYLENE: "propylène",
    ETHYLENE: "éthylène",
    AMMONIA: "ammoniac",
    POTASH: "potasse",
    PHOSPHATES: "phosphates",
    SULFUR: "soufre",
    LEATHER: "cuir",
    WOOL: "laine"
};

/** Libellé lisible d'une sous-catégorie ; un code inconnu est rendu en minuscules. */
export const subCategoryLabel = (code) => {
    if (!code) return null;
    return SUB_CATEGORY_LABELS[code] || String(code).replace(/_/g, " ").toLowerCase();
};
